module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "hero-heading"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h1', {
    staticClass: "h3 section-title",
    staticStyle: {
      "text-transform": "uppercase",
      "padding-left": "15px",
      "padding-right": "15px"
    }
  }, [_vm._v(_vm._s(_vm.header))])])]), _vm._v(" "), (_vm.expired) ? _c('div', [_c('check-expiration', {
    attrs: {
      "expired": _vm.expired
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e941efb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageHeader.vue
// module id = 374
// module chunks = 0